module.exports = __webpack_public_path__ + "img/nazuna-kouzi.e9724354.png";